import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { IemService } from '@uigy/shared/services/iem.service';
import { ConfigService } from '@uigy/shared/services/config.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { IconComponent } from '@uigy/shared/components/icons/icon/icon.component';
import { Observable, of, shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';
import { IconsEnum } from '@uigy/generated/icons.enum';
import { VendorIconComponent } from '@uigy/shared/components/icons/vendor-icon/vendor-icon.component';
import { environment } from '@env/environment';
import { Capability } from '@uigy/generated/graphql';
import { CapabilitiesService } from '@uigy/shared/capabilities/capabilities.service';
import { VendorIconsEnum } from '@uigy/generated/vendor-icons.enum';
import { LanguageService } from '@uigy/shared/services/language.service';

@Component({
  selector: 'app-em-breadcrumbs',
  templateUrl: './header-breadcrumbs.component.html',
  styleUrls: ['./header-breadcrumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IconComponent,
    AsyncPipe,
    MatTooltip,
    VendorIconComponent,
  ],
})
export class HeaderBreadcrumbsComponent {
  public readonly capabilitiesService = inject(CapabilitiesService);
  public readonly languageService = inject(LanguageService);
  public readonly tenable_workspace = this.languageService.texts.settings.integrations.tenable_workspace;
  protected readonly IconsEnum = IconsEnum;
  public icpName$: Observable<string> = of('');
  public emName$: Observable<string> = of('');
  public isTenableOneUser = this.capabilitiesService.capableOf(Capability.TOneLinks);
  public t1_url = signal<string>('');

  constructor(public iemService: IemService,
              private configService: ConfigService,
              private sanitizer: DomSanitizer,
  ) {

    // config is not available when unauthorized
    this.icpName$ = this.configService.fetchConfig(false, true).pipe(
        shareReplay(),
        map(config => {
          const baseUrl = config?.TenableCloudUrl?.Value;
          if(this.isTenableOneUser &&  baseUrl.length > 0  ) {
            this.t1_url.set(`https://${baseUrl}/tio/app.html#`);
          }
          return config?.SystemName?.Value || ' ';
        })
    );

    if (this.iemService.isIcpViewInEm()) {
      this.emName$ = this.configService.fetchConfig(true, true).pipe(
          shareReplay(),
          map(config => config?.SystemName?.Value || ' ')
      );
    }

  }

  public get emUrl(): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(window.location.origin);
  }

  protected readonly VendorIconsEnum = VendorIconsEnum;
}
